export default {
  id: 11,
  logo: require('@/assets/brain.svg'),
  name: 'agent ia',
  subtitle: 'Industrialiser les bonnes pratiques de son équipe avec les agents IA',
  description: {
    details: `Les <b>agents IA</b> changent la donne pour la <b>qualité du code</b> : bien
      configurés, ils deviennent les meilleurs gardiens des <b>standards de l'équipe</b>.
      Cette formation outille les développeurs pour codifier leurs bonnes pratiques
      (style, architecture, tests, sécurité) et les faire appliquer automatiquement
      par des agents comme Claude Code, GitHub Copilot ou Cursor. L'atelier central :
      mettre en place un <b>agent de revue de Pull Request sur mesure</b>, capable d'auditer
      le code selon les conventions de l'équipe, sur GitHub, Azure DevOps ou GitLab.`,
    goals: [
      {
        id: 1,
        content: 'Comprendre les agents IA, leurs forces et leurs angles morts'
      },
      {
        id: 2,
        content: 'Codifier les bonnes pratiques de l\'équipe pour les rendre exploitables par un agent'
      },
      {
        id: 3,
        content: 'Maîtriser le prompting et la gestion du contexte pour des résultats fiables'
      },
      {
        id: 4,
        content: 'Mettre en place un agent de revue de Pull Request adapté aux standards internes'
      }
    ],
    needs: [
      {
        id: 1,
        title: 'PUBLIC',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/developer.svg'), name: 'Développeur' },
          { id: 2, logo: require('@/assets/training/projectLeader.svg'), name: 'Tech Lead' }
        ]
      },
      {
        id: 2,
        title: 'PÉDAGOGIE',
        items: [
          { id: 1, logo: require('@/assets/training/70percent.png'), name: null }
        ]
      },
      {
        id: 3,
        title: 'PRÉ-REQUIS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/developer.svg'), name: 'Expérience en développement logiciel' },
          { id: 2, logo: require('@/assets/training/generalKnoledge.svg'), name: 'Pratique de Git' }
        ]
      },
      {
        id: 4,
        title: 'OUTILS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/claude.svg'), name: 'Claude Code' },
          { id: 2, logo: require('@/assets/training/tools/copilot.svg'), name: 'GitHub Copilot' },
          { id: 3, logo: require('@/assets/training/tools/cursor.svg'), name: 'Cursor / Windsurf' },
          { id: 4, logo: require('@/assets/training/tools/visualStudioCode.svg'), name: 'VS CODE' }
        ]
      }
    ],
    time: '2 JOURS',
    price: '300 € HT',
    trainer: 'LOIC'
  },
  program: [
    {
      id: 1,
      title: 'COMPRENDRE LES AGENTS IA',
      items: [
        { id: 1, content: 'Panorama des modèles et des agents (Claude, GPT, Copilot)' },
        { id: 2, content: 'Capacités, limites et hallucinations' },
        { id: 3, content: 'Enjeux de confidentialité et de sécurité du code' }
      ]
    },
    {
      id: 2,
      title: 'BIEN PROMPTER POUR BIEN CODER',
      items: [
        { id: 1, content: 'Principes du prompting efficace' },
        { id: 2, content: 'Fournir le bon contexte (fichiers, conventions, exemples)' },
        { id: 3, content: 'Itérer et valider les réponses de l\'agent' }
      ]
    },
    {
      id: 3,
      title: 'INTÉGRER L\'IA DANS LE QUOTIDIEN DU DÉV',
      items: [
        { id: 1, content: 'Génération et refactoring de code' },
        { id: 2, content: 'Écriture de tests unitaires et d\'intégration' },
        { id: 3, content: 'Documentation et explication de code legacy' }
      ]
    },
    {
      id: 4,
      title: 'CODIFIER LES BONNES PRATIQUES DE L\'ÉQUIPE',
      items: [
        { id: 1, content: 'Formaliser les standards (style, architecture, sécurité)' },
        { id: 2, content: 'Rédiger un fichier d\'instructions (CLAUDE.md, AGENTS.md)' },
        { id: 3, content: 'Partager et faire évoluer ces règles en équipe' }
      ]
    },
    {
      id: 5,
      title: 'ATELIER : AGENT DE REVUE DE PULL REQUEST',
      items: [
        { id: 1, content: 'Définir les critères de revue (qualité, sécurité, tests, lisibilité)' },
        { id: 2, content: 'Configurer l\'agent et son prompt système à partir des standards de l\'équipe' },
        { id: 3, content: 'Comparatif d\'intégration : GitHub Actions, Azure DevOps Pipelines, GitLab CI' },
        { id: 4, content: 'Mesurer la valeur ajoutée et faire évoluer l\'agent en continu' }
      ]
    }
  ]
}
